let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5fh6S")).then(() => parcelRequire('ap1B6'));